<nav class="navbar navbar-expand-lg navbar-dark" style="padding: 0" *ngIf="constant.IsVerified">
  <div class="container-fluid">
    <div class="header-cb">
      <div class="main-header-cb">
        <div class="cb-logo">
          <div class="logo" *ngIf="(liveUserDetail.IsShowBranding === true || liveUserDetail.IsShowBranding === null) && (virtUaluserDetail.IsShowBranding === true || virtUaluserDetail.IsShowBranding === null)">
            <a href="/" [routerLink]="['/lobby']" [queryParams]="{Token: token}"
              *ngIf="liveUserDetail.IsShowLobby === true || virtUaluserDetail.IsShowLobby === true">
              <!-- <h2>SUPERNOWA</h2> -->
              <img src="../../../assets/dealer/supernowa.gif" alt="Supernowa" title="Supernowa" />
            </a>
            <a *ngIf="liveUserDetail.IsShowLobby !== true && virtUaluserDetail.IsShowLobby !== true">
              <!-- <h2>SUPERNOWA</h2> -->
              <img src="../../../assets/dealer/supernowa.gif" alt="Supernowa" title="Supernowa" />
            </a>
          </div>
        </div>
        <div class="cb-three-col">
          <!--  && (liveUserDetail.IsShowLobby === true || virtUaluserDetail.IsShowLobby === true) -->
          <div class="mode-setting" *ngIf="(
              this.liveUserDetail.IsIframe == false && this.liveUserDetail.WebsiteURL != ''
              && this.liveUserDetail.WebsiteURL != null && this.liveUserDetail.WebsiteURL != 'null'
            )" (click)="homeRedirect()">
            <i class="fa fa-home"></i>
          </div>
          <!-- <div class="mode-setting">
            <i class="fa fa-eye" *ngIf="this.constant.isClassicView" (click)="this.constant.isClassicView = false" title="Laptop View"></i>
            <i class="fa fa-eye-slash" *ngIf="!this.constant.isClassicView"
              (click)="this.constant.isClassicView = true" title="Supernowa View" ></i>
          </div> -->
          <!-- <div class="cb-toggler">
            <p [ngClass]="{'active' : constant.isClassicView }">{{'Classic' | translate}}</p>
            <label class="switch" (change)="changeView()">
              <input type="checkbox" [checked]="!constant.isClassicView">
              <span class="slider round"></span>
            </label>
            <p [ngClass]="{'active' : !constant.isClassicView }">{{' New' | translate }}</p>
          </div> -->
          <!--  href="#newUiDesign" data-toggle="modal" -->
          <ng-container *ngIf="this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true">
            <div class="desktop-gamedropdown position-relative" (click)="displayDropdown = !displayDropdown"
              *ngIf="constant.tmpGameList.length && constant.GameCode.trim() !== '' && constant.lobbyGameDropDown">
              <span>
                {{constant.GameCode.trim() ? translateService.instant(constant.GameCode.trim()): ''}}
              </span>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.96478 5.657L0.316406 1.414L1.8666 0L4.96478 2.829L8.06297 0L9.61316 1.414L4.96478 5.657Z"
                  fill="white" />
              </svg>
              <ul class="dropdown-menu dropdown-menu-end" [ngStyle]="{display:displayDropdown === true?'block':'none'}">
                <li *ngFor="let game of constant.tmpGameList;let i=index">
                  <a class="dropdown-item active" (click)="checkGameStatus(game,i)"
                    [ngClass]="{'active': constant.GameCode.trim() == game.GameCode.trim()}">
                    {{translateService.instant(game.GameCode.trim())}}</a>
                </li>
              </ul>
            </div>
          </ng-container>
          <div class="cb-container desktop-only">
            <label class="cb-switch" [ngClass]="constant.isClassicView == false ? 'cb-slider-new':''">
              <!-- <input type="checkbox" id="toggle_vat" class="toggle_vat" [checked]="constant.isClassicView"> -->
              <div class="cb-slider cb-round">
                <span class="cb-slider_text" (click)="changeView()">
                  <span class="cb-off">Classic</span>
                  <span class="cb-on">New</span>
                </span>
                <ng-container *ngIf="isModeChangeTooltip">
                  <div class="cb-mode_tooltip">
                    <div class="cb-tooltip__container">
                      <div class="cb-tooltip__content">
                        <div class="cb__tooltip cb__tooltip-top">
                          <p class="cb-para"><span *ngIf="currentMode">{{'New' | translate }} </span>
                            <span *ngIf="!currentMode">{{'Classic' | translate }} </span>{{'Ready to switch to the' |
                            translate }}
                          </p>
                          <h5 class="cb-heading">{{'Yes, Let’s Go' | translate }}</h5>
                          <!-- ’ = &#39; -->
                          <div class="row">
                            <div class="col"><a class="cb-btn-deposit" (click)="changeView()">{{'Click Here' |
                                translate
                                }}</a></div>
                            <div class="col"><a class="cb-btn-deposit" (click)="isModeChangeTooltip = false;">{{'Close'
                                | translate }}</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="isNewInfoShow">
                  <div class="cb-main__tooltip" *ngIf="constant.isLObbyLoad && constant.isClassicView">
                    <div class="cb-tooltip__container">
                      <div class="cb-tooltip__content">
                        <div class="cb__tooltip cb__tooltip-top">
                          <h5 class="cb-heading">{{'Have you visited our new look' | translate }} ?</h5>
                          <p class="cb-para">{{'Please switch to new mode' | translate }}</p>
                          <a class="cb-btn-deposit" (click)="isNewInfoShow = false;">{{'Close' | translate }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </label>
          </div>
          <!-- [ngClass]="{'d-none': !constant.isLowBalShow}" -->
          <!-- <div class="mode-lang">
            <select #langSelect (change)="ChangeLanguage(langSelect.value);">
              <option *ngFor="let lang of constant.translate.getLangs()" [value]="lang"
                [selected]="lang === constant.translate.currentLang">{{ lang }}</option>
            </select>
          </div> -->
          <div class="dropdown shade-dropdown desktop-only">
            <button class="btn btn-secondary dropdown-toggle border-0" type="button" data-bs-toggle="dropdown">
              <span class="mx-2 d-none d-md-inline-flex">{{constant.translate.currentLang}}</span>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.96478 5.657L0.316406 1.414L1.8666 0L4.96478 2.829L8.06297 0L9.61316 1.414L4.96478 5.657Z"
                  fill="white" />
              </svg>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li *ngFor="let lang of this.allLang">
                <a class="dropdown-item active" (click)="ChangeLanguage(lang.key);"
                  [ngClass]="{'active': lang.key === constant.translate.currentLang}">{{ lang.value }}</a>
              </li>
              <!-- <li *ngFor="let lang of constant.translate.getLangs()">
                <a class="dropdown-item active" (click)="ChangeLanguage(lang);"
                  [ngClass]="{'active': lang === constant.translate.currentLang}">{{ lang }}</a>
              </li> -->
            </ul>
          </div>

          <!-- <img src="../../../assets/dealer/account-statement.svg" alt="" /> -->
          <div class="d-flex dropdown shade-dropdown d-none d-md-inline-flex">
            <button class="btn btn-secondary dropdown-toggle border-0" type="button" data-bs-toggle="dropdown">
              <img class="card-img" src="../assets/dealer/debit-card.png" />
              <span class="mx-2 d-none d-md-inline-flex">{{(constant.balance| number : '1.2-2')||0}}</span>
              <img class="arrow-bottom-img" src="../assets/dealer/bottom-arrow.png" alt="">
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li class=" d-block d-md-none">
                <a class="dropdown-item">
                  {{ 'Balance' | translate }}: {{(constant.balance| number : '1.2-2')||0}}
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/report">
                  {{ 'Total Bet' | translate }}: {{ (constant.liability| number : '1.2-2') ||0.00}}
                </a>
              </li>
            </ul>
          </div>

          <div class="d-flex dropdown no-shade">
            <button class="btn btn-secondary dropdown-toggle border-0 p-0" type="button" data-bs-toggle="dropdown"
              style="margin-right: 0;">
              <div class="my-account">
                <h4 class="m-0">{{UserName()}}</h4>
                <!-- <img class="my-account-img" src="../assets/dealer/my-account.png" alt=""> -->
                <!-- <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.96478 5.657L0.316406 1.414L1.8666 0L4.96478 2.829L8.06297 0L9.61316 1.414L4.96478 5.657Z"
                    fill="white" />
                </svg> -->
                <svg height="28" class="menu-icon" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round"
                  stroke-miterlimit="2" fill="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m11 16.745c0-.414.336-.75.75-.75h9.5c.414 0 .75.336.75.75s-.336.75-.75.75h-9.5c-.414 0-.75-.336-.75-.75zm-9-5c0-.414.336-.75.75-.75h18.5c.414 0 .75.336.75.75s-.336.75-.75.75h-18.5c-.414 0-.75-.336-.75-.75zm4-5c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75z" />
                </svg>
              </div>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li class="mobile-only">
                <label class="cb-switch" [ngClass]="constant.isClassicView == false ? 'cb-slider-new-mob':''"
                  style="width: 100%;">
                  <!-- <input type="checkbox" id="toggle_vat" class="toggle_vat" [checked]="constant.isClassicView"> -->
                  <div class="cb-slider cb-round">
                    <span class="cb-slider_text">
                      <span class="cb-off" (click)="changeView()">{{'Classic' | translate}}</span>
                      <span class="cb-on" (click)="changeView()">{{'New' | translate}}</span>
                    </span>
                  </div>
                </label>
              </li>
              <li class=" mobile-only">
                <a class="dropdown-item" href="#LanguagePopup" data-toggle="modal">
                  <i class="fa fa-language" style="height: 12px;width: 12px;color: white;"></i>
                  {{'Language' | translate }}
                </a>
              </li>
              <li>
                <!-- <a class="dropdown-item" [routerLink]="['/history']" [queryParams]="{Token: token}"> -->
                <a class="dropdown-item" href="#TransactionReportPopup" data-toggle="modal">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.28127 3C4.20668 3 4.13514 3.03161 4.0824 3.08787C4.02965 3.14413 4.00002 3.22043 4.00002 3.3C4.00002 3.37956 4.02965 3.45587 4.0824 3.51213C4.13514 3.56839 4.20668 3.6 4.28127 3.6H5.31251C5.64363 3.6 5.9305 3.804 6.06849 4.1H4.28127C4.20668 4.1 4.13514 4.1316 4.0824 4.18786C4.02965 4.24412 4.00002 4.32043 4.00002 4.4C4.00002 4.47956 4.02965 4.55587 4.0824 4.61213C4.13514 4.66839 4.20668 4.69999 4.28127 4.69999H6.13524C6.09275 4.89885 5.98821 5.07641 5.83873 5.20359C5.68925 5.33077 5.50371 5.40002 5.31251 5.39999H4.28127C4.22736 5.39999 4.17458 5.41651 4.12922 5.4476C4.08387 5.47868 4.04784 5.52302 4.02544 5.57532C4.00303 5.62763 3.99519 5.6857 4.00285 5.74262C4.01052 5.79955 4.03335 5.85292 4.06865 5.89639L6.50611 8.89638C6.55495 8.95653 6.62418 8.99353 6.69858 8.99923C6.77299 9.00493 6.84647 8.97887 6.90286 8.92678C6.95925 8.87469 6.99393 8.80084 6.99928 8.72148C7.00462 8.64211 6.98019 8.56373 6.93136 8.50358L4.89701 5.99999H5.31251C5.65301 6.00004 5.98197 5.86829 6.23831 5.62921C6.49465 5.39014 6.66096 5.05996 6.70636 4.69999H6.71874C6.79333 4.69999 6.86486 4.66839 6.91761 4.61213C6.97035 4.55587 6.99998 4.47956 6.99998 4.4C6.99998 4.32043 6.97035 4.24412 6.91761 4.18786C6.86486 4.1316 6.79333 4.1 6.71874 4.1H6.66811C6.6213 3.91938 6.54307 3.74977 6.43749 3.6H6.71874C6.79333 3.6 6.86486 3.56839 6.91761 3.51213C6.97035 3.45587 6.99998 3.37956 6.99998 3.3C6.99998 3.22043 6.97035 3.14413 6.91761 3.08787C6.86486 3.03161 6.79333 3 6.71874 3H4.28127Z"
                      fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6 0.837209C3.15026 0.837209 0.837209 3.15026 0.837209 6C0.837209 8.84974 3.15026 11.1628 6 11.1628C8.84974 11.1628 11.1628 8.84974 11.1628 6C11.1628 5.76881 11.3502 5.5814 11.5814 5.5814C11.8126 5.5814 12 5.76881 12 6C12 9.31212 9.31212 12 6 12C2.68788 12 0 9.31212 0 6C0 2.68788 2.68788 0 6 0C6.23119 0 6.4186 0.187416 6.4186 0.418605C6.4186 0.649794 6.23119 0.837209 6 0.837209Z"
                      fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M11.8648 0.101386C12.0451 0.236568 12.0451 0.45574 11.8648 0.590922L8.7879 2.89861C8.60765 3.0338 8.31542 3.0338 8.13518 2.89861C7.95494 2.76343 7.95494 2.54426 8.13518 2.40908L11.2121 0.101386C11.3923 -0.0337954 11.6846 -0.0337954 11.8648 0.101386Z"
                      fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.40909 0C8.63503 0 8.81818 0.183156 8.81818 0.409091V2.18182H10.5909C10.8168 2.18182 11 2.36497 11 2.59091C11 2.81684 10.8168 3 10.5909 3H8.40909C8.18316 3 8 2.81684 8 2.59091V0.409091C8 0.183156 8.18316 0 8.40909 0Z"
                      fill="white" />
                  </svg>
                  {{'TransactionReport' | translate }}
                </a>
              </li>
              <li>
                <!-- <a class="dropdown-item" [routerLink]="['/round']" [queryParams]="{Token: token}"> -->
                <a class="dropdown-item" href="#RoundReportPopup" data-toggle="modal">
                  <i class="fa fa-video-camera" style="height: 12px;width: 12px;" style="color: white;"></i>
                  {{'RoundHistory' | translate }}
                </a>
              </li>
              <li *ngIf="isPathGame">
                <a class="dropdown-item" href="#ChipsSettingPopup" data-toggle="modal"
                  (click)="constant.SetGameChips();">
                  <!-- <img src="../../../assets/dealer/transaction report.svg" alt=""> -->
                  <img style="height: 12px;width: 12px;"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAADAElEQVRIiZWVTYjUdRjHP8/MrEtE2zpTKuzWIYMkM9pKTS3XumSHutS5myEhdPAQnYIuFUQHSQgjkG6dPERbetHUtTJMk02WDUHKzGh2XFsWanX30+H32Ki1+vcHw3/gef9+n5fgFp56D/AC8BSwCmgC/cBlYBL4DfgW2A98ERGzVR2H+o7aVneoL6rL1b6U19Ul6pC6TR1Rf1Y3VA2wWR1Vm7dQ7bB6plZRfxAYoMBSxfltwEZgsFExQA04C3ygXgYOAt8DbaAD9FL4uBdYl873AXNRMaNXgBXAdmAlMJzfu4DFwCyF5N+BI8DhiPhDnalawTzwINCIiDFgrEJSK4CeqhzUgNXAuLpdXa3+Jzm1qT6vfggcAGpxlfABYBMFw6UUTBcB0/n/AvA5sAxYAzwMXKLLwWJgiu4cfAKcC3U58DGlU74ERoFf0/DvdN4CHqOQ9xDwRkTsVq+QOxsRk9dV0wP8ifqDulWtV8FKXaWeUtctIK+pT6r7TRxXAu2ImKsSALiYlb2rHqdA10vpqEEKV6eBHcDaUGeBE2k8QheiSUr7NdN4iALR0+n0EHCMsov+Sv3zwNGImM5qZkKdiYjb1fVpvJZC5N0UkjtpfDKd7gPeBMYjYtcCMNWBLcDOBlBXmxFxhDIkN33qsvLxiQzeS2mEQWA98CwwAcyFOp+QvAeMRMRPCzjto6zp14BngPGs7g4KJ52E6Gvgq4iY+BciCjHbKHPQyoDtNGxROOgHvgE+pczBjwtBlAkNAMcbQETEKeDVFPRTOGhxLQfnImI+ddYA/o/THuBx4DlgK/A66rz6UeJ6w5eH5eU8PNPqhHpUPZEHZko9qL6l3gfQoLTieeCkeppC9Fm6k9zK36OUNXIM+A7YC+wB7qS0aQeYjIhrKru6TevAI3R30RWILlD4GANGI2JKfZ8btOn1ZZ9Rh2+q2NVv5vncXNVgQ+I3kgd7KA94I+V96v3qS3nw2+rbVROKdLKIwvwmSgsOUFZEg7KCO5RJPgx8FhG/VA3wDwU321w/PkIdAAAAAElFTkSuQmCC" />
                  {{'ChipsSetting' | translate }}
                </a>
              </li>
              <li *ngIf="liveUserDetail.IsShowLobby === true || virtUaluserDetail.IsShowLobby === true">
                <a class="dropdown-item text-dark" [routerLink]="['/lobby']" [queryParams]="{Token: token}" href="#">
                  <!-- <img src="../../../assets/dealer/account-statement.svg" alt=""> -->
                  <img style="height: 12px;width: 12px;"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE50lEQVR4nO3aWaxdUxgH8HV60ZpKW42hpRoPbZWQhlaMFfFCBUlNNaSCJkoIHhoUCSISxBRDaBAPIoLQKmJIEEFoa0iDqqFCqIipht4Otz8Pe52c1e1OZ9r7Xrn/l3322mt9//+3zhq/tUIYwhCGMIQSgG1xLl7CO7gRI8rW1XZgR1yGb/0Xb2BY2RrbAozBDfg55/QP+Dh5P6FsrS0F9sad+Cvn+Be4CMMxNkm/omzNLQGm4FFszDm+DLPTpo4Tku8nl6m7aWAaHsfmnONv4yRUuinzUMzTiZ3L0N00cCSW5Jzuimkzeik3DD/G/EuK1Nw0oviT8H7O8Q2xFUzuh40jk3IXFKG7acSB6zysyjn+J+7G+Dps3Za0lj3aqbslwDyszTn+E67Brg3YWx1tvNUOvS0FFuQc/wrzsX2D9iYltpb1p8uUBozE31Hs9zgL2zRpc3zsNlVsxD0Y3SrdLQMOT4TOaqHdCXgEmxL7v2BOqzhaAhyXCDy1DfYn4flcF3vMQFkXyDYx66Kw19vIM1ttXSAOkge2i68uqE1ZML2NPKOwOOH6Dce0i68eYeNkixx4ps1cFVyejA2dOL2dnP0VtigK6lLAtIVTovNk+4vZ7ebsS9Ck6DwsKohzJv6InBtwXBG8vQl6OhEzriDOmUlL+BX7F8Hbk5hDkwHq9gJ5T1bbZq/GTkVxdyfmtShknQJXbrg2qfz7iuLtTsjxiZCFBfIOwyuRd4sWrkobEbM8CvkJOxTIu6dsuQxrMLwo7ryQ05NWcGnB3Jck3OUEUtEhi+7CN3rZHWIOvsOD2LtF3Csi98/YpVmbjQqZl/wT5/SQZ5vofBWduBd7Nck9K7G5oBlbzYgYLjvcgE90H/U9Tff4RxZkaSiuIFsur4y2VnXHXQhsHSk6sZvvbyZNdTpeyFXECkxrkPvCxM5RzXvTmIiR+D2KeCv37aBE4K1J+rH4NPm2CTeho07uUWobtIdb5VPdwC2JM0ck6dXN02ZMyJXZDgsTB8hOi0fVyb00lv2qVf7UDeyO9VHI4pg2RtbP4dleyk7DZ0klfIkD6uC+LClbyN6kJyH3RxFbcAYeSIQd20fZHfBEkn8dDusn74yk3Jmt8aYBYGLyj6d4Tz9GaNmofl2sQLJx5ZB+lBuudgh7c2u8aRCymF4a6v4c+9Vp43y1mMMvOLgfZarrjEcaV98iyEbmE3G0xuf4uUklrNXHokl2sAIvN6Z6AAJXJi3p7d4qU217/maRGtsOtWmUXpa7sYLg1SL1tR0YoXYKvR4Te8hX3Zq/WI/9AX8jq1KpdIYQ5sfXESGE63vIWj1aX9t2UWVALRC7We7+AUb3p5t0hwHfAhLcFZ8dIYS5uW/p0dmqYuSUAHwU/+XlufSbY3oXxpalr+2w9XWaXZP0akzgg3ptDqYuEEIIVQeHhRAmhxACpoYQpsb0pfUaHGwVkPbvfeLzqvjsCiE8Wq/BwVYBqd6OOBucHd+fq1Qq3zZjcDAgXQpvDCHcEkLYLoQghHBHIwYHWwVMSX7vG0KoRqGfrFQq75agp1io3SkmO40iu7m2T9+lBzlkZwtr/BcXl62tEMhOlvJ4qmxdhUAWKvsw5/xKjCxbWyGw9Y1y+FqTx2pVDJZZoCv5/X0I4fhKpfJDWWJKgexu8tXYrWwtQxjCEP4/+Begspv4xoU2YwAAAABJRU5ErkJggg==" />
                  {{'BackToLobby' | translate }}
                </a>
              </li>

              <!-- <li><a class="dropdown-item" href="#" (click)="Logout()"><img
                    src="../../../assets/dealer/deposit withdraw.svg" alt=""> {{'Logout' | translate }}</a></li> -->
              <!-- <li>
                       <a class="dropdown-item" routerLink="/report"><img src="../../../assets/dealer/user-profile.svg" alt=""> User Profile</a>
                    </li> -->
              <!-- <li>
                       <a class="dropdown-item" href="#"><img src="../../../assets/dealer/account-statement.svg" alt=""> Account Statement</a>
                    </li> -->
              <!-- <li>
                       <a class="dropdown-item" href="#"><img src="../../../assets/dealer/deposit withdraw.svg" alt=""> Deposit/Withdraw</a>
                    </li> -->
              <!-- <li>
                       <a class="dropdown-item" href="#"><img src="../../../assets/dealer/payment history.svg" alt=""> Payment History</a>
                    </li> -->
              <!-- <li>
                       <a class="dropdown-item" href="#"><img src="../../../assets/dealer/change password.svg" alt=""> Change Password</a>
                    </li> -->
              <!-- <li>
                       <a class="dropdown-item" href="#"><img src="../../../assets/dealer/transaction report.svg" alt=""> Transaction Report</a>
                    </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="dropdown shade-dropdown desktop-only" *ngIf="constant.tmpGameList.length">
      <button class="btn btn-secondary dropdown-toggle border-0" type="button" data-bs-toggle="dropdown">
        <span class="mx-2 d-none d-md-inline-flex">{{GameCode.trim()}}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.96478 5.657L0.316406 1.414L1.8666 0L4.96478 2.829L8.06297 0L9.61316 1.414L4.96478 5.657Z"
            fill="white" />
        </svg>
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li *ngFor="let game of constant.tmpGameList;let i=index">
          <a class="dropdown-item active" (click)="checkGameStatus(game,i)" 
            [ngClass]="{'active': GameCode.trim() == game.GameCode.trim()}">
            {{translateService.instant(game.GameCode.trim())}}</a>
        </li>
      </ul>
    </div> -->
    <ng-container *ngIf="this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true">
      <div class="navDrop mobile-gamedropdown" *ngIf="constant.lobbyGameDropDown" (click)="displayDropdown = !displayDropdown">
        <div class="navDropdown ">
          <div class="dropdown">
            <div class="dropbtn">
              {{constant.GameCode.trim() ? translateService.instant(constant.GameCode.trim()): ''}}
              <svg *ngIf="!displayDropdown" fill="white" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24">
                <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
              </svg>
              <svg *ngIf="displayDropdown" fill="white" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24">
                <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
              </svg>
            </div>
            <div class="dropdown-content"
              *ngIf="displayDropdown === true && constant.tmpGameList.length && constant.GameCode.trim() !== ''">
              <div class="dropdown-sub-content">
                <a *ngFor="let game of constant.tmpGameList;let i=index"
                  [ngClass]="{'active': constant.GameCode.trim() == game.GameCode.trim()}"
                  (click)="checkGameStatus(game,i)">
                  {{translateService.instant(game.GameCode.trim())}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>


    <!-- <div class="d-flex align-items-center">
     <div class="d-flex me-2">
        <button class="btn btn-secondary bg-transparent border-0" type="button" data-bs-toggle="dropdown">
        <img src="../assets/images/icon-person.svg" style="border-radius: 50%; vertical-align: middle;"/> <span class="mx-2 fst-italic d-none d-md-inline-flex">Welcome, ABC</span>
        </button>
     </div>
     <div class="d-flex dropdown">
        <button class="btn btn-secondary dropdown-toggle border-0" type="button" data-bs-toggle="dropdown" style="border: 1px solid #F092FF!important; background: #191F30; box-shadow: inset -5px -5px 250px rgb(255 255 255 / 2%); border-radius: 4px;">
        <img src="../assets/images/icon-card.svg" style="vertical-align: initial;"/> <span class="mx-2 d-none d-md-inline-flex">999,000,657.49</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
           <li><a class="dropdown-item text-dark" routerLink="/report">Transaction Report</a></li>
           <li><a class="dropdown-item text-dark" href="#">Logout</a></li>
        </ul>
     </div>
     </div> -->
  </div>

</nav>
<!-- <div class="bal-lib">  
    {{ 'Balance' | translate }}: {{(constant.balance| number : '1.2-2')||0}}  
  <br />  
    {{ 'Total Bet' | translate }}: {{ (constant.liability| number : '1.2-2') ||0.00}}  
</div> -->
<!-- <app-view-skeleton></app-view-skeleton> -->
<app-error *ngIf="!constant.IsVerified" [errorMessage]="displayMessage" [navigateLink]="constant.LoginLink"></app-error>
<!-- Welcome to supernowa animation div -->

<div id="LanguagePopup" class="modal fade modal-scroll" tabindex="-1" data-replace="true" data-modal-index="1">
  <div class="modal-dialog modal-lg Languageselect ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{'Language' | translate}}</h4>
        <button type="button" class="close" data-toggle="modal" data-dismiss="modal" aria-hidden="true"> x </button>
      </div>
      <div class="modal-body">
        <span class="popup-lng" *ngFor="let lang of this.allLang"
          [ngClass]="{'active': lang.key == constant.translate.currentLang}" (click)="ChangeLanguage(lang.key)">
          {{ lang.value }}
        </span>
        <!-- <li *ngFor="let lang of constant.translate.getLangs()">
            <a class="dropdown-item active" (click)="ChangeLanguage(lang);"
              [ngClass]="{'active': lang === constant.translate.currentLang}">{{ lang }}</a>
          </li> -->
      </div>
    </div>
  </div>
</div>